import { produce } from 'immer';
import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.IJackpotState = {
    jackpots: {},
    jackpotStartTime: null,
    totalCasinoJackpot: null
};

export const reducer = produce((draftState, action: Types.TJackpotsAction): Types.IJackpotState | void => {
    switch (action.type) {
        case actionTypes.SET_JACKPOTS: {
            draftState.jackpots = {
                ...draftState.jackpots,
                ...action.payload
            };

            draftState.jackpotStartTime = Date.now();

            break;
        }

        case actionTypes.SET_TOTAL_CASINO_JACKPOT: {
            draftState.totalCasinoJackpot = action.payload;

            break;
        }

        case actionTypes.CLEAR_JACKPOTS: {
            draftState.jackpots = {};
            draftState.jackpotStartTime = null;
            draftState.totalCasinoJackpot = null;

            break;
        }

        default:
            break;
    }
}, defaultState);
